import { ChangeEvent, useEffect, useState } from "react";
import { useCreateOrUpdateCalendarEventMutation, useDeleteCalendarEventMutation, useGetCalendarEventListeMutation } from "../../../api/CalendarEventAPI";
import { ICalendarEvent } from "../../../types/Types";
import { formatToStringISODate } from "../../../util/DateUtils";

interface ThisProps {
}

const toLocalDateTime = (date: Date) => {
  const pad = (value: number) => String(value).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:00`;
};

const AccountCalendarEventComponent: React.FC<ThisProps> = (props) => {

  const [getCalendarEventListeAPI] = useGetCalendarEventListeMutation();
  const [createOrUpdateAPI] = useCreateOrUpdateCalendarEventMutation();
  const [deleteAPI] = useDeleteCalendarEventMutation();

  const [liste, setListe] = useState<ICalendarEvent[]>();

  const [dto, setDto] = useState<ICalendarEvent>({ uid: "", dauerInMinuten: 30, text: "", terminISO: toLocalDateTime(new Date()) });

  const speichern = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    createOrUpdateAPI(dto).unwrap()
      .then(() => getListe())
      .catch((err) => console.log(err));

  };

  const getListe = () => {
    getCalendarEventListeAPI().unwrap()
      .then((data) => setListe(data))
      .catch((err) => console.log(err));
  }

  const changeit = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDto((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  const changedate = (e: ChangeEvent<HTMLInputElement>) => {
    const [, currentTime = "00:00"] = dto.terminISO.split("T");

    setDto((prevData) => ({
      ...prevData,
      [e.target.name]: `${e.target.value}T${currentTime.slice(0, 5)}:00`
    }));
  }

  const changetime = (e: ChangeEvent<HTMLInputElement>) => {
    const [currentDate] = dto.terminISO.split("T");
    setDto((prevData) => ({
      ...prevData,
      [e.target.name]: `${currentDate}T${e.target.value}:00`
    }));
  }

  const loeschen = (uid: string) => {
    deleteAPI(uid).unwrap()
      .then(() => getListe())
      .catch((err) => console.log(err));
  }

  useEffect(() => {
    getCalendarEventListeAPI().unwrap()
      .then((data) => setListe(data))
      .catch((err) => console.log(err));
  }, [getCalendarEventListeAPI]);

  return (
    <>

      <h4 style={{ marginTop: "50px" }}>Persönliche Termine</h4>

      <form onSubmit={speichern} style={{ marginTop: "20px", marginBottom: "20px", padding: "20px", backgroundColor: "#f8f9fa" }}>

        <h4 style={{ textAlign: "center" }}>Neuen Termin anlegen</h4>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", rowGap: "20px", padding: "40px", backgroundColor: "" }}>
          <div>
            <div>Tag</div>
            <div><input type="date" name="terminISO" value={dto.terminISO.split("T")[0]} onChange={changedate} /></div>
          </div>
          <div>
            <div>Uhrzeit</div>
            <div><input type="time" name="terminISO" value={dto.terminISO.split("T")[1]?.slice(0, 5) ?? "00:00"} onChange={changetime} /></div>
          </div>
          <div>
            <div>Dauer in Minuten</div>
            <div><input type="number" name="dauerInMinuten" value={dto?.dauerInMinuten} onChange={changeit} /></div>
          </div>
          <div>
            <div>Text</div>
            <div><input type="text" name="text" value={dto?.text} onChange={changeit} /></div>
          </div>
          <div>
            <div></div>
            <div><button className="btn btn-primary" type="submit" >Speichern</button></div>
          </div>
        </div>
      </form>

      {liste &&
        <>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr", rowGap: "20px", padding: "40px", backgroundColor: "white" }}>

            <div>Tag</div>
            <div>Uhrzeit</div>
            <div>Dauer</div>
            <div>Text</div>
            <div>Option</div>
            {liste.map((dto: ICalendarEvent) => (
              <>
                <div>
                  {dto.terminISO.split("T")[0]}
                </div>
                <div>
                  {dto.terminISO.split("T")[1]?.slice(0, 5) ?? "00:00"}
                </div>
                <div>
                  {dto.dauerInMinuten}
                </div>
                <div>
                  {dto.text}
                </div>
                <div><button className="btn btn-danger" onClick={() => loeschen(dto.uid)}>Löschen</button></div>
              </>
            ))}
          </div>
        </>
      }

    </>
  );
}

export default AccountCalendarEventComponent;
